module.exports = __webpack_public_path__ + "media/images/category/feature/coj_c/coj_c-3-8147d4175289626620decedb2eef5be3.jpg";